export default "__VITE_ASSET__$34qG8AU__"